export default function SwitchOver(props: any) {
    return (
        <svg width="44" height="44" viewBox="0 0 44 44" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
            <rect x="9" y="18" width="29" height="19" rx="1" stroke="black" strokeWidth="2" />
            <path
                d="M22.4993 25.5871C22.46 25.8193 22.525 26.057 22.677 26.2368C22.829 26.4167 23.0526 26.5204 23.2881 26.5204H24.9431L23.2838 29.7032L23.501 28.4203C23.5403 28.1881 23.4753 27.9504 23.3233 27.7705C23.1713 27.5906 22.9478 27.4868 22.7122 27.4868H21.0566L22.7171 24.2988L22.4993 25.5871Z"
                stroke="#010101"
                strokeWidth="1.6"
                strokeLinejoin="round"
            />
            <path
                d="M24.9183 6C24.9634 6 25 6.0418 25 6.0934L25 13.9066C25 13.9582 24.9634 14 24.9183 14L21.5 14C19.567 14 18 12.2091 18 10C18 7.79087 19.567 6 21.5 6L24.9183 6Z"
                stroke="black"
                strokeWidth="2"
            />
            <path d="M25 8L27.3334 8" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M25 12L27.3334 12" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <path d="M18 10L6.875 10C6.39174 10 6 10.3917 6 10.875L6 25.5L9 25.5" stroke="black" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
            <ellipse cx="14.5" cy="38" rx="1.5" ry="1" fill="black" />
            <ellipse cx="31.5" cy="38" rx="1.5" ry="1" fill="black" />
            <path d="M12 33L12 27" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M16 33L16 27" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 24H37" stroke="black" strokeWidth="2" strokeLinecap="round" />
            <path d="M32 28H37" stroke="black" strokeWidth="2" strokeLinecap="round" />
        </svg>
    );
}
